/** YouTube still-image qualities, highest first (`i.ytimg.com/vi/<id>/<quality>.jpg`). */
export const YOUTUBE_THUMBNAIL_QUALITIES = [
    "maxresdefault",
    "sddefault",
    "hqdefault",
    "mqdefault",
    "default",
];
/** Minimum width to accept each tier (YouTube serves a 120×90 stub when maxres is missing). */
export const YOUTUBE_THUMBNAIL_MIN_WIDTH = {
    maxresdefault: 1000,
    sddefault: 600,
    hqdefault: 400,
    mqdefault: 300,
    default: 100,
};
/** Build a YouTube CDN thumbnail URL for a video id. */
export function youtubeThumbnailUrl(videoId, quality = "hqdefault") {
    const id = videoId.trim();
    return `https://i.ytimg.com/vi/${id}/${quality}.jpg`;
}
/** Pull a YouTube video id from a live stream descriptor, if any. */
export function youtubeVideoIdFromRef(ref) {
    if (!ref)
        return null;
    if (ref.youtubeId?.trim())
        return ref.youtubeId.trim();
    if (ref.source?.kind === "youtube" && ref.source.src.trim())
        return ref.source.src.trim();
    return null;
}
//# sourceMappingURL=youtube.js.map